export const columnLayout = (onIncomeButtonClick, popDepartureImage) => {
  const gridColumnLayOut = [
    {
      dataField: "kakaotalkYn",
      headerText: "입차호출",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "입차호출",
        onClick: onIncomeButtonClick,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          // 행 아이템의 name 이 운송상태가 등록으로 되어 있으면  라면 버튼 표시
          if (
            (item.transStatusCd === "A" || item.transStatusCd === "G") &&
            item.tmsOdrNo !== "" &&
            item.systemCd === "DH"
          ) {
            return true;
          }
          return false;
        },
      },
      labelFunction: function (rowIndex, columnIndex, value, headerText, item) {
        if (item.transStatusCd === "G") {
          return "입차취소";
        } else if (item.transStatusCd === "A") {
          return "입차호출";
        }
        return value;
      },
    },

    {
      dataField: "systemCd",
      headerText: "회사구분",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantCd",
      headerText: "사업장구분",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantNm",
      headerText: "사업장",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "transStatusCd",
      headerText: "배차상태",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "transStatusCdNm",
      headerText: "배차상태",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      styleFunction: function (
        rowIndex,
        columnIndex,
        value,
        headerText,
        item,
        dataField
      ) {
        if (item.transStatusCd === "T" || item.transStatusCd === "R") {
          return "my-cell-style1";
        } else if (item.transStatusCd === "D") {
          return "my-cell-style2";
        } else if (item.transStatusCd === "A") {
          return "my-cell-style3";
        } else if (item.transStatusCd === "W") {
          return "my-cell-style4";
        } else if (item.transStatusCd === "S" || item.transStatusCd === "I") {
          return "my-cell-style5";
        }
        return null;
      },
    },
    {
      dataField: "arrvDt",
      headerText: "도착시간",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemCd",
      headerText: "사전등급",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemNm",
      headerText: "사전등급",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemEtcRmksNm",
      headerText: "비고2",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemEtcRmks",
      headerText: "비고2",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "inspRmks",
      headerText: "검수원비고",
      editable: true,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vndrNm",
      headerText: "공급업체",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vndrCd",
      headerText: "공급업체 코드",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "rvndrCd",
      headerText: "실공급업체 코드",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "rvndrNm",
      headerText: "실공급업체",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vhclNo",
      headerText: "차량번호",
      editable: false,

      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vhclNo4",
      headerText: "차량번호",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "drivNm",
      headerText: "운전자",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "drivTel",
      headerText: "전화번호",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "loadAreaAddr",
      headerText: "상차지역",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "startImg",
      headerText: "출발보고사진",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "사진",
        onClick: popDepartureImage,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          // 행 아이템의 name 이 운송상태가 등록으로 되어 있으면  라면 버튼 표시
          if (
            item.transStatusCd === "D" ||
            item.transStatusCd === "A" ||
            item.transStatusCd === "W" ||
            item.transStatusCd === "I" ||
            item.transStatusCd === "G" ||
            item.transStatusCd === "S"
          ) {
            return true;
          }
          return false;
        },
      },
    },
    {
      dataField: "inWeight",
      headerText: "입차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outWeight",
      headerText: "출차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outageWeight",
      headerText: "감량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "realWeight",
      headerText: "입고중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dcsnItemCdNm",
      headerText: "검수등급",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "wghtDt",
      headerText: "입고일자",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemEtcCdNm",
      headerText: "비고1",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemEtcCd",
      headerText: "비고1",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "tmsOdrSeq",
      headerText: "배차순번",
      editable: false,
      //visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "tmsOdrNo",
      headerText: "배차번호",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
  ];
  return gridColumnLayOut;
};
